import { Suspense, useEffect } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { theme } from "../redux/customise/customiseActions";

// Router
import {
    BrowserRouter,
    Route,
    Switch,
    useHistory
} from "react-router-dom";

// Routes
import { Routes } from "./routes";

// Layouts
import VerticalLayout from "../layout/VerticalLayout";
import HorizontalLayout from "../layout/HorizontalLayout";
import FullLayout from "../layout/FullLayout";

// Components
import Ecommerce from "../view/main/dashboard/ecommerce";
import LoginPage from "../view/pages/authentication/login";
import RegPage from "../view/pages/authentication/register";
import PwResetPage from "../view/pages/authentication/reset-password";
import PwRecoverPage from "../view/pages/authentication/recover-password";
import Error404 from "../view/pages/errors/404";

export default function Router() {

    // Redux
    const customise = useSelector(state => state.customise)
    const dispatch = useDispatch()
    const user = localStorage.getItem("token")


    // Location
    const location = useHistory()

    // Dark Mode
    let themeLocal

    useEffect(() => {
        if (localStorage) {
            themeLocal = localStorage.getItem("theme")
        }

        if (themeLocal === "light" || themeLocal === "dark") {
            document.querySelector("body").classList.add(themeLocal)
            dispatch(theme(themeLocal))
        } else {
            document.querySelector("body").classList.add(customise.theme)
            dispatch(theme(customise.theme))
        }
    }, [])

    // RTL
    useEffect(() => {
        if (customise.direction == "ltr") {
            document.querySelector("html").setAttribute("dir", "ltr");
        } else if (customise.direction == "rtl") {
            document.querySelector("html").setAttribute("dir", "rtl");
        }
    }, [])

    // Url Check
    useEffect(() => {
        // Theme
        if (location.location.search == "?theme=dark") {
            localStorage.setItem("theme", "dark")
            themeLocal = "dark"
        } else if (location.location.search == "?theme=light") {
            localStorage.setItem("theme", "light")
            themeLocal = "light"
        }

        // Direction
        if (location.location.search == "?direction=ltr") {
            document.querySelector("html").setAttribute("dir", "ltr");
        } else if (location.location.search == "?direction=rtl") {
            document.querySelector("html").setAttribute("dir", "rtl");
        }
    }, [])

    // Default Layout
    const DefaultLayout = customise.layout; // FullLayout or VerticalLayout

    // All of the available layouts
    const Layouts = { VerticalLayout, HorizontalLayout, FullLayout };

    // Return Filtered Array of Routes & Paths
    const LayoutRoutesAndPaths = (layout) => {
        const LayoutRoutes = [];
        const LayoutPaths = [];
        if (Routes) {
            // Checks if Route layout or Default layout matches current layout
            Routes.filter(route => (route.layout === layout) && (
                LayoutRoutes.push(route),
                LayoutPaths.push(route.path)
            ));
        }

        return { LayoutRoutes, LayoutPaths };
    };

    // Return Route to Render
    const ResolveRoutes = () => {
        return Object.keys(Layouts).map((layout, index) => {
            const { LayoutRoutes, LayoutPaths } = LayoutRoutesAndPaths(layout);

            let LayoutTag;
            if (DefaultLayout == "HorizontalLayout") {
                if (layout == "VerticalLayout") {
                    LayoutTag = Layouts["HorizontalLayout"];
                } else {
                    LayoutTag = Layouts[layout];
                }
            } else {
                LayoutTag = Layouts[layout];
            }

            return (
                <Route path={LayoutPaths} key={index}>
                    <LayoutTag>
                        <Switch>
                            {LayoutRoutes.map((route) => {
                                return (
                                        <Route
                                            key={route.path}
                                            path={route.path}
                                            exact={route.exact === true}
                                            render={(props) => {
                                                return (
                                                    <Suspense fallback={null}>
                                                        <route.component {...props} />
                                                    </Suspense>
                                                );
                                            }}
                                        />

                                );
                            })}
                        </Switch>
                    </LayoutTag>
                </Route>
            );

        });
    };

    
    if(!!user){
        return (
            <BrowserRouter>
                <Switch>
                    {ResolveRoutes()}

                    {/* Home Page */}
                        <Route
                            exact
                            path={'/'}
                            render={() => {
                                return (
                                    DefaultLayout == "HorizontalLayout" ? (
                                        <Layouts.HorizontalLayout>
                                            <Ecommerce />
                                        </Layouts.HorizontalLayout>
                                    ) : (
                                        <Layouts.VerticalLayout>
                                            <Ecommerce />
                                        </Layouts.VerticalLayout>
                                    )
                                )
                            }}
                        />
                   
                        {/* NotFound */}
                        <Route path='*'>
                            <Error404 />
                        </Route>
                </Switch>
            </BrowserRouter>
        );
    }else{
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/">
                        <LoginPage />
                    </Route>
                    <Route exact path="/registration">
                        <RegPage />
                    </Route>
                    <Route exact path="/pw-reset">
                        <PwResetPage />
                    </Route>
                    <Route exact path="/pw-recover">
                        <PwRecoverPage />
                    </Route>
                    <Route path='*'>
                            <Error404 />
                    </Route>
                </Switch>
            </BrowserRouter>
        );
    }
};